import { render, staticRenderFns } from "./setAmountExams.view.vue?vue&type=template&id=27a55c12&scoped=true"
import script from "./setAmountExams.view.vue?vue&type=script&lang=js"
export * from "./setAmountExams.view.vue?vue&type=script&lang=js"
import style0 from "./setAmountExams.view.vue?vue&type=style&index=0&id=27a55c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a55c12",
  null
  
)

export default component.exports